import { EditorByline } from '@/components/EditorByline'
import { EditorContentSource } from '@/components/EditorContentSource'
import { MetaBarRow } from './MetaBarRow'
import { isArticleType } from '@/lib/isArticleType'
import type { YDocument } from '@/modules/yjs/hooks'
import { useYValue } from '@/modules/yjs/hooks'
import type { JSX } from 'react'
import type * as Y from 'yjs'

/**
 * The fields that live on the editor surface, at the top of the text, scrolling
 * with it rather than staying pinned in view.
 * Gated here rather than per field, so nothing but empty padding is left behind
 * on the document types that have neither, such as the print editor.
 */
export const EditorMetaBar = ({ ydoc, readOnly }: {
  ydoc: YDocument<Y.Map<unknown>>
  readOnly?: boolean
}): JSX.Element | null => {
  const [documentType] = useYValue<string | undefined>(ydoc.ele, 'root.type')

  if (!isArticleType(documentType)) {
    return null
  }

  return (
    <MetaBarRow>
      <EditorByline ydoc={ydoc} readOnly={readOnly} />
      <EditorContentSource ydoc={ydoc} readOnly={readOnly} />
    </MetaBarRow>
  )
}
